import { JsonSchemaConditionPropertiesFormProperties } from "./audit-event.model";

export class AuditConditionForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaConditionPropertiesFormProperties;
}



// WEBPACK FOOTER //
// ./src/app/views/audit/models/audit-condition.model.ts